<app-profile-accounts [type]="'individual'"></app-profile-accounts>
<router-outlet></router-outlet>